// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__M3bSa","description":"PatientConsentPreview_description__3QDMx"};